import Cookies from "js-cookie";

const TokenKey = "accessToken";
const UuidKey = "Uu-id";
const url = 'url' //token失效页面

const treeId = 'treeId'

const schoolLogo = 'schoolLogo'

export function getSchoolLogo() {
  return Cookies.get(schoolLogo);
}

export function setSchoolLogo(val) {
  return Cookies.set(schoolLogo, val);
}

export function removeSchoolLogo() {
  return Cookies.remove(schoolLogo);
}

export function getTreeId() {
  return Cookies.get(treeId);
}

export function setTreeId(val) {
  return Cookies.set(treeId, val);
}

export function removeTreeId() {
  return Cookies.remove(treeId);
}

export function getUrl() {
  return Cookies.get(url);
}

export function setUrl(val) {
  return Cookies.set(url, val);
}

export function removeUrl() {
  return Cookies.remove(url);
}

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

export function getUserId() {
  return Cookies.get("userId");
}

export function setUserId(userId) {
  return Cookies.set("userId", userId);
}

export function removeUserId() {
  return Cookies.remove("userId");
}
// 用户名 账号
export function getUserName() {
  return Cookies.get("UserName");
}

export function setUserName(UserName) {
  return Cookies.set("UserName", UserName);
}

export function removeUserName() {
  return Cookies.remove("UserName");
}
// 昵称
export function getNickName() {
  return Cookies.get("NickName");
}

export function setNickName(NickName) {
  return Cookies.set("NickName", NickName);
}

export function removeNickName() {
  return Cookies.remove("NickName");
}
// 真实姓名
export function getRealName() {
  return Cookies.get("RealName");
}

export function setRealName(RealName) {
  return Cookies.set("RealName", RealName);
}

export function removeRealName() {
  return Cookies.remove("RealName");
}

// 头像路径
export function getAvatarPath() {
  return Cookies.get("AvatarPath");
}

export function setAvatarPath(AvatarPath) {
  return Cookies.set("AvatarPath", AvatarPath);
}

export function removeAvatarPath() {
  return Cookies.remove("AvatarPath");
}

// 电话号
export function getPhone() {
  return Cookies.get("Phone");
}

export function setPhone(Phone) {
  return Cookies.set("Phone", Phone);
}

export function removePhone() {
  return Cookies.remove("Phone");
}

// 邮箱
export function getEmail() {
  return Cookies.get("Email");
}

export function setEmail(Email) {
  return Cookies.set("Email", Email);
}

export function removeEmail() {
  return Cookies.remove("Email");
}

// 角色id
export function getRoleId() {
  return Cookies.get("RoleId");
}

export function setRoleId(RoleId) {
  return Cookies.set("RoleId", RoleId);
}

export function removeRoleId() {
  return Cookies.remove("RoleId");
}

export function clearCookie() {
  var keys = document.cookie.match(/[^ =;]+(?=\=)/g);
  if (keys) {
    for (var i = keys.length; i--; ) {
      document.cookie =
        keys[i] + "=0;path=/;expires=" + new Date(0).toUTCString(); //清除当前域名下的,例如：m.kevis.com
      document.cookie =
        keys[i] +
        "=0;path=/;domain=" +
        document.domain +
        ";expires=" +
        new Date(0).toUTCString(); //清除当前域名下的，例如 .m.kevis.com
      document.cookie =
        keys[i] +
        "=0;path=/;domain=kevis.com;expires=" +
        new Date(0).toUTCString(); //清除一级域名下的或指定的，例如 .kevis.com
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/auth.js